import script from "./FeaturesBg.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturesBg.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./FeaturesBg.vue?vue&type=style&index=0&id=59105bdd&module=features_bg&lang=css"
cssModules["features_bg"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__